export type WindowWithDatalayer = {
  dataLayer: {
    push: (args: FullDataLayerObject) => void
  }
}

export const hasDatalayer = (w: any): w is WindowWithDatalayer => w['dataLayer'] != undefined

export const pushDataLayer = (d: FullDataLayerObject) => {
  if (hasDatalayer(window)) {
    window.dataLayer.push(d)
  } else {
    console.log("No dataLayer variable present to push ", d)
  }
}

export type FullDataLayerObject = {
  event: string
  category: string
  action?: string
  label?: string
}

export type DataLayerObject = Omit<FullDataLayerObject, 'event'>